<template>
  <div v-show="loading"> 
 	  <el-skeleton :rows="10" animated />
  </div>
  <!--begin::Tables Widget 11-->
  <div :class="widgetClasses" class="card" v-show="!loading">
    <!--begin::Header-->
    <div class="card-header border-0 pt-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label fw-bolder fs-3 mb-1">Direct Sponsored List
           &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span>
      </h3>
      
    </div>
    <!--end::Header-->
    <!--begin::Body-->
    <div class="card-body py-3">

      <div class="row">
        <div class="col-md-3 fv-row">
            <!--begin::Input group-->
            <div class="d-flex flex-column mb-7 fv-row">
              <!--begin::Label-->
              <label class="fs-6 fw-bold form-label mb-2" >From Date</label
              >
              <!--end::Label-->

              <!--begin::Input wrapper-->
              <div class="position-relative">
                <!--begin::Input-->
                  <input type="date" class="form-control form-control-solid" placeholder="" format="DD/MM/yyyy" name="from_date" v-model="from_date">
                <!--end::Input-->
              </div>
              <!--end::Input wrapper-->
            </div>
            <!--end::Input group-->
        </div> 
        <div class="col-md-3 fv-row">
            <!--begin::Input group-->
            <div class="d-flex flex-column mb-7 fv-row">
              <!--begin::Label-->
              <label class="fs-6 fw-bold form-label mb-2" >To Date</label
              >
              <!--end::Label-->

              <!--begin::Input wrapper-->
              <div class="position-relative">
                <!--begin::Input-->
                <input type="date" class="form-control form-control-solid" placeholder="" format="DD/MM/yyyy" name="to_date" v-model="to_date">
                <!--end::Input-->
              </div>
              <!--end::Input wrapper-->
            </div>
            <!--end::Input group-->
        </div> 
        <div class="col-md-3 fv-row">
          <div class="d-flex flex-column mb-7 fv-row">
              <!--begin::Label-->
              <label class="fs-6 fw-bold form-label mb-9" ></label
              >
              <!--end::Label-->

              <!--begin::Input wrapper-->
              <div class="position-relative">
                <!--begin::Input-->
                <button type="button" class="btn btn-primary er fs-6 px-8 py-2" v-on:click="directsponsoredhistory();" > View </button>
                <!--end::Input-->
              </div>
              <!--end::Input wrapper-->
            </div>
        </div>
      </div>











      <!--begin::Table container-->
      <div class="table-responsive">
        <!--begin::Table-->
        <table class="table align-middle gs-0 gy-4">
          <!--begin::Table head-->
          <thead>
            <tr class="fw-bolder text-muted bg-light">
              <th class="ps-4 min-w-125px rounded-start">#</th>
              <th class="min-w-225px">Fullname</th>
              <th class="min-w-200px">Date</th>
              <th class="min-w-200px">Sponsor</th>
            </tr>
          </thead>
          <!--end::Table head-->
          <!--begin::Table body-->
          <tbody>
            <template v-for="(item, index) in list" :key="index">
              <tr>
                <td>&nbsp;&nbsp;&nbsp;{{item.id}}</td>
                <td>{{item.usid}} - {{item.upref}} / {{item.packagestatus}} / {{item.userFullname}}</td>
                <td>{{item.dteStp}}</td>
                <td>{{item.sponsorFullname}} ({{item.spid}})</td>
              </tr>
            </template> 
          </tbody>
          <!--end::Table body-->
        </table>
        <!--end::Table-->
      </div>
      <!--end::Table container-->
    </div>
    <!--begin::Body-->
  </div>
  <!--end::Tables Widget 11-->
</template>

<script lang="ts">
import { defineComponent } from "vue";
import {loadPaginatedDirectSponsor}  from "@/api/directsponsored";

export default defineComponent({
  name: "directsponsoredhistory", 
  methods: {
    async directsponsoredhistory(){ 
      this.loading = true;
      let params = {"page" : 1, "f" : this.from_date + " 00:00:00","t" : this.to_date + " 23:59:59"}
      const response = await loadPaginatedDirectSponsor(params);
      this.list = response.data.pageList;
      this.loading = false;
    },
  },
  mounted(){
      this.directsponsoredhistory();
  },
  data(){
      return { 
        list : [],
        loading: true,
        to_date :  new Date().toISOString().substr(0, 10),
        from_date: new Date().toISOString().substr(0, 10),
      }
  },
  components: {
  },
  props: {
    widgetClasses: String
  }
});

</script>
